import { FluidGridProps } from '@design-system/fluid-grid';
import { ImageBlockProps } from '@design-system/image-block';
import { SearchResultsHeaderProps } from '@design-system/search-results-header';

import { ArticleSearchResult } from '../../services/search/config/articles/types';
import { EventSearchResult } from '../../services/search/config/events/types';
import { ProductSearchResult } from '../../services/search/config/products/types';
import { ResourceSearchResult } from '../../services/search/config/resources/types';

export enum SearchingState {
  pending = 'pending',
  results = 'results',
  noResults = 'noResults',
  emptyPhrase = 'emptyPhrase',
}

export enum TabsVariant {
  allResults = 0,
  productsTab = 1,
  articlesTab = 2,
  eventsTab = 3,
  resourcesTab = 4,
}

export interface SearchResultsProps {
  resultsTab: string;
  productTab: string;
  articleTab: string;
  resourceTab: string;
  eventTab: string;
  moreResultsButtonLabel: string;
  moreProductsButtonLabel: string;
  moreArticlesButtonLabel: string;
  moreResourcesButtonLabel: string;
  moreEventsButtonLabel: string;
  initialVisibleItems: number;
  header: SearchResultsHeaderProps;
  imageSettings: ImageBlockProps;
  fluidGrid: FluidGridProps;
  locale: string;
  uid: string;
  componentId?: string;
}

export interface ArticleListingProps {
  items: Array<ArticleSearchResult>;
  maxVisibleItems?: number;
  tabNumber: number;
  setTabValue: (value: number) => void;
  moreButtonText: string;
  imageSettings: ImageBlockProps;
  fluidGrid: FluidGridProps;
  tabItemsTitle?: React.ReactNode;
}

export interface ResourceListingProps {
  items: Array<ResourceSearchResult>;
  maxVisibleItems?: number;
  tabNumber: number;
  setTabValue: (value: number) => void;
  moreButtonText: string;
  imageSettings: ImageBlockProps;
  fluidGrid: FluidGridProps;
  tabItemsTitle?: React.ReactNode;
}

export interface EventListingProps {
  items: Array<EventSearchResult>;
  maxVisibleItems?: number;
  tabNumber: number;
  setTabValue: (value: number) => void;
  moreButtonText: string;
  imageSettings: ImageBlockProps;
  fluidGrid: FluidGridProps;
  tabItemsTitle?: React.ReactNode;
}

export interface ProductListingProps {
  items: Array<ProductSearchResult>;
  imageSettings: ImageBlockProps;
  maxVisibleItems?: number;
  tabNumber: number;
  setTabValue: (value: number) => void;
  moreButtonText: string;
  fluidGrid: FluidGridProps;
  tabItemsTitle?: React.ReactNode;
}

export interface SearchResultSkeletonProps {
  initialVisibleItems: number;
}
